export { TimepickerComponent } from './timepicker.component';
export { TimepickerActions } from './reducer/timepicker.actions';
export { TimepickerStore } from './reducer/timepicker.store';
export { TimepickerConfig } from './timepicker.config';
export { TimepickerModule } from './timepicker.module';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
